import { Navigate } from 'react-router-dom';

export const UserConfigList = () => <Navigate to="/organization_config" />;

export default UserConfigList;
